module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/2_7354e685eb4abc361f8890127e78ce7f.jpg";